import React, { useState } from "react";
import Modal from './index';
import Input from '../Form/Input';
import FormGroup from "../Form/FormGroup";
import Button from "../Form/Button";
import { MdWorkOutline } from "react-icons/md";
import FormGroupInline from '../Form/FormGroupInline';
import Select from '../Form/Select';
import { FaPencilAlt } from "react-icons/fa";
import { getOptionByOptionList } from "../../utils/utils";
import { useAuth } from "../../contexts/authContext";
import BreakForm from "./../Form/BreakForm";
import InfoTooltip from "../InfoTooltip";

const ModalRole = ({ isNew = false, value = {}, editable = false, setEdit, onSubmit, closeModal }) => {
    const [role, setRole] = useState(value)
    const [permissions, setPermissions] = useState(value.permissions || {})

    const { permissions: userPermissions, verifyIfModuleIsActive } = useAuth()
    const whatsappInboxesPermission = permissions?.whatsapp_inboxes ?? (permissions?.integrations >= 1 ? 3 : 0)

    const optionsAccess = [
        { id: 0, value: "Sem acesso" },
        { id: 1, value: "Acesso Parcial" },
        { id: 2, value: "Acesso Total" },
    ]
    const optionsAccessManager = [
        { id: 0, value: "Sem acesso" },
        { id: 1, value: "Acesso Total" },
    ]
    const optionsAccessAccountManager = [
        { id: 0, value: "Sem acesso" },
        { id: 1, value: "Acesso Parcial" },
        { id: 2, value: "Acesso Total" },
    ]
    const optionsAccessWhatsAppInboxes = [
        { id: 0, value: "Sem acesso" },
        { id: 1, value: "Acessar próprias caixas e templates" },
        { id: 2, value: "Acessar próprias caixas, templates e adicionar novas" },
        { id: 3, value: "Acesso total a todas as caixas e adicionar novas" },
    ]
    const optionsAccessEmail = [
        { id: 0, value: "Sem acesso" },
        { id: 1, value: "Visualizar" },
        { id: 2, value: "Gerenciar" },
    ]
    const optionsAccessDuplicates = [
        { id: 0, value: "Sem acesso" },
        { id: 1, value: "Ver fila e auditoria" },
        { id: 3, value: "Revisar e mesclar duplicidades" },
    ]
    const optionsRodizio = [
        { id: 0, value: "Não, usuários desse cargo não participam do rodízio automático" },
        { id: 1, value: "Sim, usuários desse cargo recebem leads do rodízio automático" },
    ]

    const handleChangeValue = (name, value) => {
        setRole(previousValue => { return { ...previousValue, [name]: value } })
    }

    const handleChangeValuePermissions = (name, value) => {
        setPermissions(previousValue => {
            const newValue = { ...previousValue, [name]: value }
            handleChangeValue("permissions", newValue)
            return newValue
        })

    }

    const getDuplicatePermissionValue = () => {
        const permission = Number(permissions?.duplicates || 0)
        if (permission === 3) return 3
        if (permission >= 1) return 1
        return 0
    }

    const renderPermissionField = ({ key, label, options, value, selected, tooltip }) => {
        const selectedValue = selected !== undefined ? selected : (permissions?.[key] ?? '')
        return (
            <FormGroup
                key={key}
                labelText={label}
                labelContent={tooltip ? <InfoTooltip text={tooltip} preferredPosition="bottom" /> : undefined}
            >
                {editable ?
                    <Select multiple={false} name="Selecione o nível de acesso" placeholder="Buscar" options={options} selected={selectedValue} onChange={(value) => handleChangeValuePermissions(key, value)} />
                    :
                    <span>{getOptionByOptionList(selectedValue, options)}</span>
                }
            </FormGroup>
        )
    }

    const renderPermissionRows = (items = []) => {
        const rows = []
        for (let i = 0; i < items.length; i += 2) {
            rows.push(
                <FormGroupInline key={`permission-row-${items[i].key}`}>
                    {items.slice(i, i + 2).map(renderPermissionField)}
                </FormGroupInline>
            )
        }
        return rows
    }

    const mainPermissions = [
        { key: "dashboard", label: "Dashboard", options: optionsAccessManager, tooltip: "Permite acessar os indicadores e painéis gerais da conta." },
        { key: "crm", label: "Kanban", options: optionsAccess, tooltip: "Controla o acesso ao funil de leads. Acesso parcial limita ações; acesso total permite operar o CRM." },
        { key: "duplicates", label: "Fila de Duplicidades", options: optionsAccessDuplicates, selected: getDuplicatePermissionValue(), tooltip: "Ver fila e auditoria permite acompanhar possíveis duplicidades. Revisar e mesclar permite concluir decisões, manter separados, ignorar e consolidar leads." },
        { key: "reports", label: "Relatórios", options: optionsAccessManager, tooltip: "Permite acessar relatórios e exportações disponíveis para a conta." },
        { key: "tasks", label: "Lista de Tarefas", options: optionsAccessManager, tooltip: "Permite acessar a lista operacional de tarefas dos leads." },
        { key: "notes", label: "Histórico de anotações", options: optionsAccessManager, tooltip: "Permite visualizar o histórico de anotações dos leads." },
        { key: "call_log", label: "Histórico de Chamadas", options: optionsAccessManager, tooltip: "Permite acessar o registro de chamadas da conta." },
    ]

    const managementPermissions = [
        { key: "manage_roles", label: "Gerenciar Cargos", options: optionsAccessManager, tooltip: "Permite criar e editar cargos e suas permissões." },
        { key: "manage_teams", label: "Gerenciar Equipes", options: optionsAccessManager, tooltip: "Permite criar, editar e organizar equipes." },
        { key: "manage_users", label: "Gerenciar Usuários", options: optionsAccessManager, tooltip: "Permite cadastrar, editar e remover usuários da conta." },
        { key: "settings", label: "Configurações da Conta", options: optionsAccessManager, tooltip: "Permite alterar configurações gerais, governança e preferências da conta." },
        { key: "import", label: "Importação em Massa", options: optionsAccessManager, tooltip: "Permite importar leads em massa." },
        { key: "integrations", label: "Integrações", options: optionsAccessManager, tooltip: "Permite configurar integrações externas da conta." },
        { key: "whatsapp_inboxes", label: "Caixas WhatsApp", options: optionsAccessWhatsAppInboxes, selected: whatsappInboxesPermission, tooltip: "Controla quais caixas e templates de WhatsApp esse cargo pode acessar ou administrar." },
        { key: "edit_funnels", label: "Edição de Funil", options: optionsAccessManager, tooltip: "Permite criar e editar funis e etapas do CRM." },
        { key: "config_new_leads", label: "Configurar Leads Novos (Integrações)", options: optionsAccessManager, tooltip: "Permite definir como novos leads de integrações entram no CRM." },
        { key: "finance", label: "Minha Conta / Financeiro da Conta", options: optionsAccessManager, tooltip: "Permite acessar dados financeiros e informações da conta." },
    ]

    const handleCancel = (e) => {
        e.preventDefault()
        if (isNew) {
            closeModal()
        } else {
            setEdit(false)
            setRole(value)
            setPermissions(value.permissions || {})
        }
    }

    return (
        <Modal
            icon={<MdWorkOutline />}
            title={isNew ? "Cadastro de novo cargo" : (editable ? `Editando o cargo: ${role.name}` : `Visualizando: ${role.name}`)}
            description={isNew ? "Adicione um novo cargo a sua conta" : (editable ? "Altere as informações abaixo" : `Caso queira editar as informações clique no ícone de edição`)}
            closeModal={closeModal}
        >
            <form onSubmit={(e) => onSubmit(e, isNew, role)}>
                <FormGroupInline>
                    <FormGroup labelText="Nome">
                        {editable ?
                            <Input type="text" placeholder="Nome do cargo" value={role.name ?? ""} onChange={(e) => handleChangeValue("name", e.target.value)} invalid={true} textInvalid="Preencha o nome do cargo" />
                            :
                            <span>{role.name}</span>
                        }
                    </FormGroup>
                    {!editable &&
                        <Button variant="secondary" className="action" onClick={() => setEdit(true)}>
                            <FaPencilAlt />
                        </Button>
                    }
                </FormGroupInline>
                <BreakForm title="Acesso Operacional" showAction={false} />
                {renderPermissionRows([
                    ...mainPermissions,
                    ...(verifyIfModuleIsActive("CHAT") ? [{ key: "chat", label: "Chat", options: optionsAccess, tooltip: "Controla o acesso às conversas e atendimento via chat." }] : []),
                ])}
                <BreakForm title="Administração da Conta" showAction={false} />
                {renderPermissionRows(managementPermissions)}
                <FormGroupInline>
                    <FormGroup labelText="Rodízio Automático de Leads">
                        {editable ?
                            <Select multiple={false} name="Selecione uma opção" placeholder="Buscar" options={optionsRodizio} selected={(+role?.rodizio)?.toString()} onChange={(value) => handleChangeValue("rodizio", value)} />
                            :
                            <span>{getOptionByOptionList(+role?.rodizio, optionsRodizio) || "-"}</span>
                        }
                    </FormGroup>
                </FormGroupInline>
                <FormGroupInline>
                    <FormGroup labelText="Rodízio Automático de Chats">
                        {editable ?
                            <Select multiple={false} name="Selecione uma opção" placeholder="Buscar" options={optionsRodizio} selected={(+role?.rodizio_chat)?.toString()} onChange={(value) => handleChangeValue("rodizio_chat", value)} />
                            :
                            <span>{getOptionByOptionList(+role?.rodizio_chat, optionsRodizio) || "-"}</span>
                        }
                    </FormGroup>
                </FormGroupInline>
                {userPermissions?.is_partner > 0 &&
                    <>
                        <BreakForm title="Permissões do Parceiro" showAction={false} />
                        <FormGroupInline>
                            <FormGroup labelText="Gerenciar Contas">
                                {editable ?
                                    <Select multiple={false} name="Selecione o nível de acesso" placeholder="Buscar" options={optionsAccessAccountManager} selected={permissions?.manage_accounts ?? ''} onChange={(value) => handleChangeValuePermissions("manage_accounts", value)} />
                                    :
                                    <span>{getOptionByOptionList(permissions?.manage_accounts, optionsAccessAccountManager)}</span>
                                }
                            </FormGroup>
                        </FormGroupInline>
                    </>
                }
                {userPermissions?.is_admin > 0 &&
                    <>
                        <BreakForm title="Permissões Administrativas" showAction={false} />
                        <FormGroupInline>
                            <FormGroup labelText="Gerenciar Contas" labelContent={<InfoTooltip text="Acesso parcial permite somente visualizar. Acesso total permite todas as ações de gestão de contas, incluindo módulos, plano e recursos, sem exigir a permissão de gerenciar planos." />}>
                                {editable ?
                                    <Select multiple={false} name="Selecione o nível de acesso" placeholder="Buscar" options={optionsAccessAccountManager} selected={permissions?.manage_accounts ?? ''} onChange={(value) => handleChangeValuePermissions("manage_accounts", value)} />
                                    :
                                    <span>{getOptionByOptionList(permissions?.manage_accounts, optionsAccessAccountManager)}</span>
                                }
                            </FormGroup>
                            <FormGroup labelText="Gerenciar Planos">
                                {editable ?
                                    <Select multiple={false} name="Selecione o nível de acesso" placeholder="Buscar" options={optionsAccessManager} selected={permissions?.manage_plans ?? ''} onChange={(value) => handleChangeValuePermissions("manage_plans", value)} />
                                    :
                                    <span>{getOptionByOptionList(permissions?.manage_plans, optionsAccessManager)}</span>
                                }
                            </FormGroup>
                        </FormGroupInline>
                        <FormGroupInline>
                            <FormGroup labelText="Instâncias WhatsApp">
                                {editable ?
                                    <Select multiple={false} name="Selecione o nível de acesso" placeholder="Buscar" options={optionsAccessManager} selected={permissions?.manage_whatsapp_instances ?? ''} onChange={(value) => handleChangeValuePermissions("manage_whatsapp_instances", value)} />
                                    :
                                    <span>{getOptionByOptionList(permissions?.manage_whatsapp_instances, optionsAccessManager)}</span>
                                }
                            </FormGroup>
                            <FormGroup labelText="Financeiro Interno">
                                {editable ?
                                    <Select multiple={false} name="Selecione o nível de acesso" placeholder="Buscar" options={optionsAccessManager} selected={permissions?.manage_finance ?? ''} onChange={(value) => handleChangeValuePermissions("manage_finance", value)} />
                                    :
                                    <span>{getOptionByOptionList(permissions?.manage_finance, optionsAccessManager)}</span>
                                }
                            </FormGroup>
                        </FormGroupInline>
                        <FormGroupInline>
                            <FormGroup labelText="Modelos de E-mail">
                                {editable ?
                                    <Select multiple={false} name="Selecione o nível de acesso" placeholder="Buscar" options={optionsAccessEmail} selected={permissions?.manage_email_templates ?? ''} onChange={(value) => handleChangeValuePermissions("manage_email_templates", value)} />
                                    :
                                    <span>{getOptionByOptionList(permissions?.manage_email_templates, optionsAccessEmail)}</span>
                                }
                            </FormGroup>
                            <FormGroup labelText="Comunicados por E-mail">
                                {editable ?
                                    <Select multiple={false} name="Selecione o nível de acesso" placeholder="Buscar" options={optionsAccessEmail} selected={permissions?.manage_email_campaigns ?? ''} onChange={(value) => handleChangeValuePermissions("manage_email_campaigns", value)} />
                                    :
                                    <span>{getOptionByOptionList(permissions?.manage_email_campaigns, optionsAccessEmail)}</span>
                                }
                            </FormGroup>
                        </FormGroupInline>
                    </>
                }
                {editable &&
                    <FormGroupInline>
                        <Button variant='primary' type="submit">Salvar</Button>
                        <Button variant='secondary' onClick={handleCancel}>Cancelar</Button>
                    </FormGroupInline>
                }
            </form>
        </Modal>
    )
}

export default ModalRole
